import { useModulePermissions } from "@/context/ModulePermissionsContext";
import { useIsAdmin } from "@/hooks/useIsAdmin";

/** Whether the signed-in user may run mission/stage/task admin overrides. */
export function useCanMissionOps(): boolean {
  const isAdmin = useIsAdmin();
  const { hasPermission } = useModulePermissions();
  return isAdmin || hasPermission("ops");
}
